<template>
  <fb-form-properties-manager id="dropdown-v2-properties-xdahxl" :fields="fields" :formId="formId" />
</template>

<script>
export default {
  name: "DropdownV2Properties",
  props: ["formId"],
  data() {
    return {
      fields: [
        {
          type: "textInput",
          properties: {
            label: "Label"
          },
          property: "label"
        },
        {
          type: "multipleText",
          properties: {
            label: "Options",
            allowCollections: true
          },
          property: "options"
        },
        {
          type: "textInput",
          properties: {
            label: "Description"
          },
          property: "description"
        },
        {
          type: "checkbox",
          properties: {
            label: "Required",
            disabled: element => {
              return !(element.properties.hidden == false || element.properties.hidden == "{{!(true)}}");
            }
          },
          property: "required"
        },
        {
          type: "checkbox",
          properties: {
            label: "Allow multiple options",
            disabled: element => {
              return element.properties.includeOther ? true : false;
            }
          },
          property: "multiselect"
        },
        {
          type: "textInput",
          properties: {
            label: "Max Number of Selected Items ",
            type: "number",
            minValue: 0
          },
          property: "maxOptions"
        },
        {
          type: "checkbox",
          properties: {
            label: 'Include option "Other"',
            disabled: element => {
              return element.properties.multiselect ? true : false;
            }
          },
          property: "includeOther"
        },
        {
          type: "checkbox",
          properties: {
            label: "Editable in Patient Portal"
          },
          property: "eFormEditable"
        },
        {
          type: "checkbox",
          properties: {
            label: "Hide in view mode"
          },
          property: "hideOnView"
        },
        {
          type: "conditionEditor",
          properties: {
            label: "Visibility condition",
            updateValueMiddleware: (value) => {return value.replace("{{(","{{!(")}
          },
          property: "hidden"   
        }
      ]
    };
  }
};
</script>

<style></style>
